function determineBrand() {
  const projectId = process.env.GATSBY_SANITY_PROJECT_ID;
  if (projectId === "o289pg0s") return "everyday";
  if (projectId === "6lh54ymz") return "professional";
  if (projectId === "tdld5dwk") {
    if (process.env.GATSBY_IBAN === "au") return "barkers-aus";
    return "barkers-nz";
  }
  if (projectId === "pbpon7tg") return "anathoth";
  return "barkers-nz";
}

function getIndexValues() {
  const brand = determineBrand();
  const iban = process.env.GATSBY_IBAN?.toString();

  if (brand === "everyday") {
    return {
      products: "everyday_products",
      blogs: "everyday_blogs",
      recipes: "everyday_recipes",
    };
  }

  if (brand === "professional") {
    return {
      products: "pro_products_nz",
      blogs: "pro_blogs",
      recipes: "pro_recipes",
    };
  }

  if (brand === "anathoth") {
    return {
      products: "anathoth_products",
      blogs: "anathoth_blogs",
      recipes: "anathoth_recipes",
    };
  }

  return {
    products: iban === "au" ? "products" : "products_nz",
    blogs: "blogs",
    recipes: "recipes",
  };
}

module.exports = {
  determineBrand,
  getIndexValues,
};
